module.exports = __webpack_public_path__ + "img/img-success-package.6c227581.svg";